import React from 'react';

import { TableBody } from '@mui/material';

import { arrayValidation } from 'utils/array';

import NoResults from 'components/shared/CustomTable/NoResults';
import TableBodySpinner from 'components/shared/CustomTable/TableBodySpinner';
import CurrentTableContext from 'components/shared/CustomTable/context';

import CustomRenderRow from './CustomRenderRow';

interface Props {
  rows: Array<any>;
  center?: boolean;
}

const CustomTableBody = ({ rows = [], center }: Props) => {
  const {
    isLoading,
    messageNoResult = '',
    renderRow,
    columns,
  } = React.useContext(CurrentTableContext);

  if (isLoading) {
    return <TableBodySpinner />;
  }

  if (!arrayValidation(rows)) {
    return (
      <TableBody>
        <NoResults
          message={messageNoResult}
          center={center}
          colSpan={columns.length}
        />
      </TableBody>
    );
  }

  return (
    <TableBody>
      {rows.map((row, index) => (
        <React.Fragment key={index}>
          {renderRow ? (
            renderRow(row, index, columns)
          ) : (
            <CustomRenderRow row={row} index={index} columns={columns} />
          )}
        </React.Fragment>
      ))}
    </TableBody>
  );
};

export default CustomTableBody;
